function asDays(value: unknown): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function roundLeaveDays(value: number): number {
  return Math.round(value * 100) / 100;
}

/**
 * Available leave is opening + credited + adjusted - used - pending.
 * When a stored available was clamped to zero, the ledger still yields the
 * true signed remainder (including negatives).
 */
export function computeSignedLeaveAvailable(row: {
  openingBalance?: unknown;
  creditedDays?: unknown;
  adjustedDays?: unknown;
  debitedDays?: unknown;
  pendingLeaveDays?: unknown;
  availableBalance?: unknown;
}): number | null {
  const stored = Number(row.availableBalance);
  const storedDays = Number.isFinite(stored) ? stored : null;
  const hasLedger = [
    row.openingBalance,
    row.creditedDays,
    row.adjustedDays,
    row.debitedDays,
    row.pendingLeaveDays,
  ].some(value => value !== undefined && value !== null && value !== '');
  if (!hasLedger) return storedDays;
  const computed = roundLeaveDays(
    asDays(row.openingBalance) +
      asDays(row.creditedDays) +
      asDays(row.adjustedDays) -
      asDays(row.debitedDays) -
      asDays(row.pendingLeaveDays),
  );
  if ((storedDays == null || Math.abs(storedDays) < 1e-9) && computed < -1e-9) return computed;
  return storedDays ?? computed;
}

export function leaveBalanceDisplayColor(
  value: number | null | undefined,
  positiveColor: string,
  negativeColor: string,
): string {
  if (value != null && Number.isFinite(value) && value < 0) return negativeColor;
  return positiveColor;
}
